<script>
// Class options list:
// flex-row | selected | primary | focused | disabled | inactive | no-border | col-2 | col-3
// Variant options: solid (default) | outline | ghost

export default {
  name: 'AppButton',
  props: {
    brand: { type: String, default: null, validator: (value) => value === 'zelle' },
    selected: Boolean,
    focused: Boolean,
    disabled: Boolean,
    nativeDisabled: Boolean,
    variant: {
      type: String,
      default: 'solid',
      validator: (value) => ['solid', 'outline', 'ghost'].includes(value)
    }
  },
  methods: {}
};
</script>

<template>
  <button v-bind="$attrs" v-on="$listeners" :disabled="disabled && nativeDisabled" class="p-2.5 app-button" :class="[variant, brand && `brand-${brand}`, { selected, focused, disabled }]">
    <slot />
  </button>
</template>
